import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const ChangPasswordApi = createApi({
  reducerPath: "ChangPasswordApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    UpdatePassword: builder.mutation({
      query: ({ Token, data }) => ({
        url: `/user/changePassword`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      invalidatesTags: ["change"],
    }),

    forgotPassword: builder.mutation({
      query: ({ email, role }) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body: { email, role },
      }),
    }),

    resetPassword: builder.mutation({
      query: (formData) => ({
        url: "/auth/reset-password",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const {
  useUpdatePasswordMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = ChangPasswordApi;
